// export const backendUrl = "http://localhost:3000";

export const backendUrl = "https://api.abzarmoalem.ir";
